import React, { Component } from 'react';
// import logo from './logo.svg';
import Tickers from './components/Tickers.js';
import { Link, Route, Switch } from 'react-router-dom';
import golbeldata from './data.json';
import Home  from './components/Home.js';
import Rooms  from './components/Rooms.js';
import Reservation  from './components/Reservation.js';
import Gallery  from './components/Gallery.js';
import Contact  from './components/Contact.js';
import Explore  from './components/Explore.js';
import './App.css';

class App extends Component {

  constructor(props) {
    super(props);

    this.concerts = golbeldata;
  }

  componentDidMount() {
    //concerts: golbeldata
  }

  render() {   
    return (
      <Switch>
      <Route exact path="/" component={Home}/>
      <Route path="/rooms" component={Rooms}/>
       <Route path="/reservation" component={Reservation}/>
       <Route path="/explore" component={Explore}/>
       <Route path="/gallery" component={Gallery}/>
       <Route path="/contact" component={Contact}/>
    </Switch>

      );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js